import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-full pb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col h-full"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mt-1 mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "flex space-x-1 mb-1"
}
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = {
  key: 1,
  class: "flex space-x-1"
}
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = {
  key: 2,
  class: "banner banner-light mt-4"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, "timer", -1)
const _hoisted_12 = { class: "mt-auto" }
const _hoisted_13 = {
  key: 1,
  class: "w-full mb-4 banner banner-danger"
}
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "flex items-center space-x-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-danger-dark" }, " school ", -1)
const _hoisted_17 = { class: "font-semibold text-danger-dark" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "text-danger-dark" }
const _hoisted_22 = { class: "flex items-center mt-8 space-x-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-0 material-icons-outlined" }, " school ", -1)
const _hoisted_24 = { class: "flex flex-col w-full" }
const _hoisted_25 = {
  key: 2,
  class: "mb-1 mr-auto text-muted text-danger-dark"
}
const _hoisted_26 = {
  key: 3,
  class: "mb-1 mr-auto text-muted text-danger-dark"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-xl material-icons-outlined" }, " login ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-xl material-icons-outlined" }, " login ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_StudentScopesBanner = _resolveComponent("StudentScopesBanner")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.metaStore.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton)
        ]))
      : (_ctx.mainStore.previewingEvent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.mainStore.previewingEvent.name), 1),
            (_ctx.mainStore.previewingEvent.instructions.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "mb-4 overflow-hidden overflow-ellipsis",
                  innerHTML: _ctx.mainStore.previewingEvent.instructions
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.mainStore.previewingEvent.begin_timestamp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("event_editor.begin_timestamp")) + ":", 1),
                    _createVNode(_component_Timestamp, {
                      value: _ctx.mainStore.previewingEvent.begin_timestamp
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mainStore.previewingEvent.end_timestamp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("event_editor.end_timestamp")) + ":", 1),
                    _createVNode(_component_Timestamp, {
                      value: _ctx.mainStore.previewingEvent.end_timestamp
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true),
              (
						_ctx.mainStore.previewingEvent.time_limit_rule === _ctx.EventTimeLimitRule.TIME_LIMIT
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t("event_participation_page.exam_has_time_limit_warning_1")) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.timeLimitMinutes) + " " + _toDisplayString(_ctx.$t("misc.minutes")), 1),
                        _createTextVNode(", " + _toDisplayString(_ctx.$t("event_participation_page.exam_has_time_limit_warning_2")), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("event_participation_page.exam_has_time_limit_warning_3")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (!_ctx.metaStore.user.is_teacher)
                ? (_openBlock(), _createBlock(_component_StudentScopesBanner, { key: 0 }))
                : _createCommentVNode("", true),
              (
						!_ctx.metaStore.user.is_teacher &&
						!_ctx.isDemoMode &&
						(!_ctx.metaStore.user.mat || !_ctx.metaStore.user.course)
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_17, [
                            _createTextVNode(_toDisplayString(_ctx.$t("student_data.you_havent_yet")) + " ", 1),
                            (!_ctx.metaStore.user.mat)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("student_data.missing_mat")), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.metaStore.user.mat && !_ctx.metaStore.user.course)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, " " + _toDisplayString(_ctx.$t("student_data.and")) + " ", 1))
                              : _createCommentVNode("", true),
                            (!_ctx.metaStore.user.course)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("student_data.missing_course")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("student_data.insert_mat_and_course")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_NumberInput, {
                            class: "mb-8 w-96 text-darkText",
                            modelValue: _ctx.dirtyMat,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dirtyMat) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("student_data.your_mat")), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_RadioGroup, {
                            options: _ctx.courseSelectionOptions,
                            modelValue: _ctx.dirtyCourse,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dirtyCourse) = $event)),
                            class: "text-darkText"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("student_data.your_course")), 1)
                            ]),
                            _: 1
                          }, 8, ["options", "modelValue"]),
                          _createVNode(_component_Btn, {
                            variant: 'primary',
                            loading: _ctx.localLoading,
                            disabled: String(_ctx.dirtyMat).length === 0 || _ctx.dirtyCourse.length === 0,
                            onClick: _ctx.onSaveStudentData,
                            class: "ml-auto"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("misc.save_and_close")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mainStore.previewingEvent.state === _ctx.EventState.PLANNED)
                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t("event_participation_page.exam_not_yet_begun")), 1))
                : (_ctx.mainStore.previewingEvent.state === _ctx.EventState.CLOSED)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t("event_participation_page.exam_is_over")), 1))
                  : _createCommentVNode("", true),
              (
						_ctx.canParticipate &&
						(_ctx.metaStore.user.is_teacher ||
							_ctx.isDemoMode ||
							(_ctx.metaStore.user.mat && _ctx.metaStore.user.course))
					)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 4,
                    to: {
						name: 'ExamParticipationPage',
						params: {
							examId: _ctx.eventId,
						},
					}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Btn, {
                        size: 'lg',
                        class: "mr-auto"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _createTextVNode(_toDisplayString(_ctx.$t("event_participation_page.participate")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createBlock(_component_Btn, {
                    key: 5,
                    size: 'lg',
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28,
                      _createTextVNode(_toDisplayString(_ctx.$t("event_participation_page.participate")), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}